import { render, staticRenderFns } from "./SleepTestMovie.vue?vue&type=template&id=585c2adb&scoped=true&"
import script from "./SleepTestMovie.vue?vue&type=script&lang=js&"
export * from "./SleepTestMovie.vue?vue&type=script&lang=js&"
import style0 from "./SleepTestMovie.vue?vue&type=style&index=0&id=585c2adb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585c2adb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
